module.exports = __webpack_public_path__ + "img/a1xtd-tu85p.7f6c862c.png";